import script from "./AreaSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./AreaSelector.vue?vue&type=script&lang=ts&setup=true"

import "./AreaSelector.vue?vue&type=style&index=0&id=a46a7c50&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a46a7c50"]])

export default __exports__